





































import {computed, defineComponent, ref} from "@vue/composition-api";
import SelectParametersGroup from "@tool/Components/SelectParametersGroup.vue";
import Alert from "@base/Components/Alert.vue";
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import {BvModalEvent} from "bootstrap-vue";
import useBuilderStore from "@tool/store/useBuilderStore";
import {useToast} from "vue-toastification/composition";
import FormError from "@tool/Components/FormError.vue";
import useFormHelper, {FormErrorResponse} from "@tool/Helpers/useFormHelper";
import {axiosErrorTransformer} from "@tool/Helpers/useAxios";

export default defineComponent({
    components: {
        FormError,
        SelectParametersGroup,
        Alert
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        modelValue: {
            type: Boolean,
            default: false
        },
        modeCreate: {
            type: Boolean,
            default: true,
        },
    },

    setup(props, {emit}) {

        const localShow = computed<boolean>({
            get() {
                return props.show;
            },
            set(newValue: boolean) {
                emit('update:show', newValue);
            }
        });

        const {formParameters, saveTemplate} = useBuilderStore();

        const form = useFormHelper({
            name: '',
            active: true,
            notes: '',
        });

        const formValidator = useVuelidate({
            name: {
                required
            }
        }, form.value.data);

        const isSelectedAtLeastOneParameter = computed(() => {
            return formParameters.value.utm_source !== null ||
                    formParameters.value.utm_campaign !== null ||
                    formParameters.value.utm_content !== null ||
                    formParameters.value.utm_medium !== null ||
                    formParameters.value.utm_term !== null;
        });

        const formHandle = async (event: BvModalEvent) => {
            event.preventDefault();

            await handleSavingTemplate(event);
        }

        const toast = useToast();
        const formErrors = ref<FormErrorResponse | null>(null);

        const handleSavingTemplate = async (event: BvModalEvent) => {

            if (formValidator.value.$invalid) {
                await event.preventDefault();
                toast.success('Please make sure you filled out all required fields.')
                return;
            }

            formErrors.value = null;

            try {
                await saveTemplate(
                        form.value.data.name,
                        formParameters.value,
                        form.value.data.active,
                        form.value.data.notes
                );

                toast.success('Template was successfully saved');

                localShow.value = false;
            } catch (e) {
                const axiosError = axiosErrorTransformer(e);
                formErrors.value = {
                    message: axiosError.message,
                    errors: axiosError.errors,
                }
            }

        }

        const onHidden = () => {
            form.value.data.name = '';
            form.value.data.notes = '';
            form.value.data.active = true;
            formErrors.value = null;
        }

        return {
            localShow,
            isSelectedAtLeastOneParameter,
            form,
            formErrors,
            formValidator,
            formHandle,
            onHidden,
        }
    }
});
